import React from "react";
import EditIcon from "./EditIcon";

function EditButton({ onClick, label = "Edit item", title, disabled = false }) {
  return (
    <button
      type="button"
      aria-label={label}
      title={title}
      disabled={disabled}
      className="flex h-8 w-8 items-center justify-center rounded bg-blue-200 text-blue-800 hover:bg-blue-300 disabled:cursor-not-allowed disabled:opacity-50"
      onClick={onClick}
    >
      <EditIcon className="w-4 h-4" />
    </button>
  );
}

export default EditButton;
